import Axios from 'axios';

const model = 'sessions';

export function getSession(sessionId) {
  return Axios({
    method: 'GET',
    url: `${model}/${sessionId}`,
    headers: {
      'X-Fora-Key': sessionId
    }
  }).then((res) => res?.data);
}
